import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Splide from '@splidejs/splide';

class Gallery {
    constructor(el) {
        this.el = el
        this.inner = this.el.querySelector('[data-gallery--inner]')
        this.slider = this.el.querySelector('[data-gallery--slider]')
        this.loader = this.el.querySelector('[data-gallery--loader]')
        this.prev = this.el.querySelector('[data-gallery--prev]')
        this.next = this.el.querySelector('[data-gallery--next]')

        this.splide = null

        this.bind()
        this.init()
    }

    bind() {
        this.onPrevClick = this.onPrevClick.bind(this)
        this.onNextClick = this.onNextClick.bind(this)

        this.prev.addEventListener('click', this.onPrevClick)
        this.next.addEventListener('click', this.onNextClick)
    }

    unbind() {
        this.prev.removeEventListener('click', this.onPrevClick)
        this.next.removeEventListener('click', this.onNextClick)
    }

    init() {
        this.splide = new Splide(this.slider, {
            type: 'loop',
            height: '500px',
            focus: 'center',
            autoWidth: true,
            gap: 32,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            interval: 2000,
            arrows: false,
            pagination: false,
        })

        this.splide.on('mounted', () => {
            this.loader.style.display = 'none'

            setTimeout(() => {
                this.splide.root.style.opacity = 1
            }, 300)
        });

        setTimeout(() => {
            this.loader.style.display = 'none'
            this.splide.mount()
        }, 2000)

        this.anim = gsap.fromTo(this.el, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'out',
            scrollTrigger: {
                trigger: this.el,
                start: 'top 90%',
                end: 'bottom 10%',
                invalidateOnRefresh: true,
                // markers: true,
            },
        });
    }

    onPrevClick(e) {
        e.preventDefault()
        e.stopImmediatePropagation()
        this.splide.go('-${i}')
    }

    onNextClick(e) {
        e.preventDefault()
        e.stopImmediatePropagation()
        this.splide.go('+${i}')
    }

    destroy() {
        this.unbind();
        this.splide && this.splide.destroy();
        this.anim && this.anim.kill();
    }
}


export default {
    when() {
        return document.querySelectorAll('[data-gallery]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-gallery]').forEach(gallery => {
            const instance = new Gallery(gallery)
            this.instances.push(instance);
        })
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
